import React from 'react';

/**
 * Consistent pill toggle for settings pages.
 * size="md" (default) → w-12 h-6, size="sm" → w-10 h-5
 */
export default function Toggle({ enabled, onToggle, disabled = false, size = 'md' }) {
  const isMd = size === 'md';
  const track = isMd
    ? 'w-12 h-6'
    : 'w-10 h-5';
  const thumb = isMd
    ? `w-5 h-5 top-0.5 ${enabled ? 'translate-x-6' : 'translate-x-0.5'}`
    : `w-4 h-4 top-0.5 ${enabled ? 'translate-x-5' : 'translate-x-0.5'}`;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      onClick={onToggle}
      disabled={disabled}
      className={[
        track,
        'rounded-full relative flex-shrink-0 overflow-hidden transition-colors duration-200',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-brand-400',
        enabled ? 'bg-emerald-400' : 'bg-gray-200',
        disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer',
      ].join(' ')}
    >
      <span
        className={[
          'absolute bg-white rounded-full shadow-sm transition-transform duration-200',
          thumb,
        ].join(' ')}
      />
    </button>
  );
}
